module.exports = __webpack_public_path__ + "img/pengeluaran.5b739c39.jpg";